module.exports = __webpack_public_path__ + "static/img/gxqy001.d999c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/gxqy001.png
// module id = hdyv
// module chunks = 1